module.exports = __webpack_public_path__ + "img/img06.2bd95103.jpg";